import helpers from '../helpers';
import {intro} from './animations';
import {initRain} from '../main';
import parallax from './parallax';
import recomendation from './recomendation';
let test;
let time = 0;
class Test {
	constructor($page) {
		this.$test = $page.find('.test');
		this.$step = this.$test.find('.test__step');
		this.$stepInner = this.$step.find('.test__step-inner');
		this.$stepIntro = this.$step.find('.test__intro');
		this.$stepQuestion = this.$step.find('.test__question');
		this.$stepAnswer = this.$step.find('.test__answer');
		this.$stepInput = this.$test.find('.test__input');
		this.$testFooterShare = this.$test.find('.test__footer-share');

		this.$stepCurrent = this.$test.find('[data-step="1"]');

		this.final = false;
		this.counter = 0;

		this.init();
	}

	init() {
		this.stepOpen(1);
		this.stepOpen('inner');

		if (helpers.getCookie('recommendation')) {
			helpers.$document.trigger('show-test-intro', [this.$test.parent().data('name')]);
			this.stepOpen('intro');
		} else {
			recomendation.init();
		}

		helpers.$window.on('scroll.test', () => {
			const winBottom = window.pageYOffset + window.innerHeight;

			if (winBottom + 30 > $('.test__footer').offset().top) {
				//$('.footer').fadeOut(200);
			} else {
				//$('.footer').fadeIn(200);
			}
		});

		helpers.$body
			.on('click.test', '.test__button', (e) => {
				const $step = $(e.currentTarget).closest('.test__step');
				const step = $(e.currentTarget).data('id');
				const oldStep = $(e.currentTarget).parent().closest('[data-step]').data('step');
				this.final = $(e.currentTarget).data('final');

				if (step === 'question') {
					helpers.$document.trigger('click-test-intro-button', [
						this.$test.parent().data('name'),
						$step.data('step'),
						$step.find('.test__intro p').text(),
					]);
				}
				if (step === 'answer') {
					const right = this.isRight ? 'Yes' : 'No';
					const count = this.isRight ? 1 : 0;
					this.counter += count;

					helpers.$document.trigger('click-test-answer-button', [
						this.$test.parent().data('name'),
						$step.data('step'),
						`${right} - ${this.questionText}`,
						count,
					]);
				}

				this.stepClose(oldStep).then(() => {
					this.stepOpen(step);
				});
			});

		this.$stepInput.on('change.test', (e) => {
			this.isRight = $(e.currentTarget).data('right');
			this.questionText = $(e.currentTarget).siblings('label').text();

			$(e.currentTarget).closest('.test__question').find('.test__button').removeAttr('disabled').removeClass('is-disabled');

			this.$stepCurrent.find('.right').toggleClass('is-hidden', !this.isRight);

			if (this.isRight) {
				this.$stepCurrent.find('.notright').addClass('is-hidden');
			} else {
				this.$stepCurrent.find('.notright').removeClass('is-hidden');
			}
		});

		this.$testFooterShare
			.on('mouseenter', (e) => {
				const color = $(e.currentTarget).data('color');

				this.$testFooterShare.addClass('is-hide');
				$(e.currentTarget).removeClass('is-hide');
				$(e.currentTarget).closest('.test__footer-item').css({
					backgroundColor: color,
				});
			})
			.on('mouseleave', (e) => {
				this.$testFooterShare.removeClass('is-hide');
				$(e.currentTarget).closest('.test__footer-item').removeAttr('style');
			});
	}

	destroy() {
		helpers.$body.off('.test');
		helpers.$window.off('.test');
		this.$stepInput.off('.test');
	}

	stepOpen(id) {
		const self = this;
		// eslint-disable-next-line no-nested-ternary
		const $step = typeof id === 'number' ? this.$step.filter(`[data-step="${id}"]`) :
			id === 'final' ? self.$test.find(`[data-step="${id}"]`) : this.$stepCurrent.find(`[data-step="${id}"]`);

		if (typeof id === 'number') {
			helpers.$document.trigger('show-test-step', [this.$test.parent().data('name'), id, $step.find('.test__intro p').text()]);
			parallax.disable();
		}

		if (id === 'final') {
			helpers.$document.trigger('show-test-final', [
				this.$test.parent().data('name'),
				$step.find('.intro__text').text(),
				this.counter,
			]);
		}
		const tl = gsap.timeline({
			onStart() {
				if (typeof id === 'number') {
					parallax.init(self.$test);
					setTimeout(() => {
						parallax.enable();
					}, 100);
				}
				tl.set($step, {
					position: 'absolute',
					left: 0,
					top: 0,
				});
				helpers.scrollTo($step);
				if (id === 'inner-bg') {
					const video = $step.find('video');
					const light = $step.data('theme');
					if (light === 'light') {
						$('.header').addClass('light');
					}
					if (video.length > 0) {
						video.trigger('play');
						time = 500;
					}
				}
			},
			onComplete() {
				$step.removeAttr('style');


				if (id === 'inner-bg') {
					const step = $step.parent().next().data('step');
					const oldStep = $step.parent().data('step');
					const video = $step.find('video');
					// меняем активный шаг чтобы внутренние элементы брали правильные дочерние элементы
					self.$stepCurrent = this.final ? self.$test.find(`[data-step="${step}"]`) : self.$step.filter(`[data-step="${step}"]`);

					if (video.length > 0) {
						const rain = $step.parent().next().find('#bg-img');
						helpers.$document
							.on('video-end', () => {
								time = 0;
								console.log('video-end');
								$('.header').removeClass('light');
								helpers.debounce(() => {
									self.stepClose(oldStep).then(() => {
										self.stepOpen(step);
										if (rain.length > 0) {
											const canvas = document.createElement('canvas');
											$(canvas).attr('id', 'rain');
											$(rain).append(canvas);
											setTimeout(() => {
												initRain();
											}, 1000);
										}
										if (step !== 'final') {
											self.stepOpen('inner');
											self.stepOpen('intro');
										} else {
											intro();
										}
									});
								}, 100);
							})
						;
					} else {
						helpers.debounce(() => {
							self.stepClose(oldStep).then(() => {
								self.stepOpen(step);

								if (step !== 'final') {
									self.stepOpen('inner');
									self.stepOpen('intro');
								} else {
									intro();
								}
							});
						}, 2000);
					}
				}
			},
		});

		tl.from($step, {
			autoAlpha: 0,
			duration: id === 'inner-bg' ? 0.3 : 0.5,
			onStart() {
				setTimeout(() => {
					$step.removeClass('is-hidden');
				}, time);
			},
		});

		if (id === 'intro' || id === 'question' || id === 'answer') {
			tl.from($step.find('> *'), {
				y: 100,
				autoAlpha: 0,
				stagger: 0.2,
				duration: 0.3,
				clearProps: 'all',
				onStart() {
					$step.find('> *').css({
						transition: 'none',
					});
				},
			});
		}
	}

	stepClose(id) {
		const self = this;

		return new Promise((resolve) => {
			// eslint-disable-next-line no-nested-ternary
			const $step = typeof id === 'number' ? this.$step.filter(`[data-step="${id}"]`) : this.$stepCurrent.find(`[data-step="${id}"]`);

			const tl = gsap.timeline({
				onComplete() {
					$step.addClass('is-hidden');
					self.$test.removeAttr('style');

					if (id === 'inner-bg') {
						parallax.disable();
					}

					resolve();
				},
			});

			if (id === 'intro' || id === 'question') {
				tl.to($step.find('> *'), {
					y: 100,
					autoAlpha: 0,
					duration: 0.3,
					ease: 'back.out(1.2)',
					stagger: {
						amount: 0.2,
						from: 'end',
					},
					onStart() {
						$step.find('> *').css({
							transition: 'none',
						});
					},
				});
			}

			if (id === 'answer' || id === 'inner-bg') {
				tl.to($step.closest('.test__step-inner'), {
					autoAlpha: 0,
				});
			} else {
				tl.to($step, {
					autoAlpha: 0,
				});
			}
		});
	}
}

function init($page) {
	test = new Test($page);
}

function destroy() {
	test.destroy();
}

export default {
	init,
	destroy,
};
